import { useCallback } from "react";
import { buildGoogleMapsUrl } from "../../lib/build-google-maps-url";
import { buildStaticMapUrl } from "../../lib/build-static-maps-url";

interface StaticMapProps {
  className?: string;
  lat: number;
  lng: number;
  clickToOpenInGoogleMaps?: boolean;
}

const StaticMap: React.FC<StaticMapProps> = ({
  className,
  lat,
  lng,
  clickToOpenInGoogleMaps,
}) => {
  const mapUrl = buildStaticMapUrl(lat, lng, {
    width: 600,
    height: 300,
    showMarker: true,
    markerColor: "yellow",
  });

  const handleClick = useCallback(() => {
    if (clickToOpenInGoogleMaps) {
      window.open(buildGoogleMapsUrl(lat, lng), "_blank");
    }
  }, [clickToOpenInGoogleMaps, lat, lng]);

  return (
    <div className={className} onClick={handleClick}>
      <img src={mapUrl} alt="Map" />
    </div>
  );
};

export default StaticMap;
